module.exports = __webpack_public_path__ + "media/images/front/pc/cancer-information/doctor01-6a986272446ea66750412de7ec71b256.png";